import styled from "styled-components";
import { Layout, List } from "antd";
import Button from "common/button";
import { Content } from "antd/lib/layout/layout";

export const StyledContent = styled(Content)`
  padding-top: 0;
  margin-top: 0;
`;

export const CustomLayout = styled(Layout)`
  width: 300px;
  max-height: 375px;
  text-align: left;
`;

export const CustomListItem = styled(List.Item)`
  display: flex;
  justify-content: flex-start;
`;

export const CustomImage = styled.img`
  margin: auto auto -28px auto;
  width: 200px;
  &.icon {
    width: 60px;
    margin: 0 auto;
  }
`;

export const CustomButton = styled(Button)`
  &.toggle-btn {
    background-color: #d3e8ff;
    width: 100%;
    margin-top: 20px;
    &.yes {
      background: #1070b6;
      color: #fdd440;
    }
  }
  &.placement {
    margin-top: 0px;
  }
  &.to-flexi-btn {
    margin-top: 20px;
    width: 280px;
  }
  @media (min-width: 700px) {
    &.toggle-btn {
      width: 48.6%;
    }

    &.placement {
      width: 50%;
      display: flex;
    }
    &.full {
      width: 100%;
    }
  }
`;

export const NumberBullet = styled.div`
  background: #d3e8ff;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  line-height: 28px;
  font-size: 14px;
  font-weight: bold;
  color: #1070b6;
  text-align: center;
  margin-left: 16px;
  margin-right: 16px;
`;

export const CardTitle = styled.div`
  font-family: "Myriad Pro", Myriad, "Liberation Sans", "Nimbus Sans L",
    "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: bolder;
  color: #1070b6;
  background-color: #d3e8ff;
  text-align: center;
  font-size: 16px;
  transform: scaleY(1.07);
  padding: 10px 20px;
  .icon-btn {
    all: unset;
    cursor: pointer;
    position: absolute;
    top: 7px;
    left: 16px;
  }
  .icon {
    width: 20px;
  }
  &.step1 {
    text-align: left;
  }
`;

export const CustomCard = styled.div`
  padding: 20px;
  font-family: "Myriad Pro", Myriad, "Liberation Sans", "Nimbus Sans L",
    "Helvetica Neue", Helvetica, Arial, sans-serif;
  .timezone {
    font-weight: bolder;
    color: #1070b6;
  }
  .change {
    padding: 0;
  }
  &.step1 {
    width: 300px;
    background-color: white;
    padding: 0;
  }
  &.step2 {
    width: 300px;
    background-color: #f6f6f6;
    padding: 0;
    text-align: left;
  }
  &.step3 {
    width: 300px;
    padding: 0;
    text-align: left;
    background-color: #f6f6f6;
  }
  &.step4 {
    width: 300px;
    padding: 0;
    text-align: left;
    background-color: white;
    p {
      color: black;
      padding: 4px 0 4px 16px;
      margin: 4px 0;
    }
    .ant-col {
      color: black;
    }
    .block {
      line-height: 1.3;
      padding: 10px 10px 10px 0;
    }
  }
  @media (min-width: 700px) {
    &.step3 {
      width: 700px;
      &.page1 {
        width: 300px;
      }
    }
  }
  @media (min-width: 700px) {
    .buttons {
      display: flex;
      justify-content: space-between;
    }
  }
`;
